import sendRequest from "./send-request";
// import { sendMultipartRequest } from "./send-request"
const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function index(params = {}) {
  const query =
    params instanceof URLSearchParams
      ? params.toString()
      : new URLSearchParams(params).toString();
  return sendRequest(`${BASE_URL}/stamps${query ? `?${query}` : ""}`, "GET");
}

export async function filterOptions() {
  return sendRequest(`${BASE_URL}/stamps/filter-options`, "GET");
}

export async function hiddenIndex(params = {}) {
  const query =
    params instanceof URLSearchParams
      ? params.toString()
      : new URLSearchParams(params).toString();
  return sendRequest(
    `${BASE_URL}/stamps/hidden${query ? `?${query}` : ""}`,
    "GET",
  );
}

export async function create(data) {
  return sendRequest(`${BASE_URL}/stamps`, "POST", data);
}

export async function getMostRecentStamp() {
  return sendRequest(`${BASE_URL}/stamps/most-recent`, "GET");
}

export async function detail(id) {
  return sendRequest(`${BASE_URL}/stamps/${id}`, "GET");
}

export async function destroy(id) {
  return sendRequest(`${BASE_URL}/stamps/${id}`, "DELETE");
}

export async function update(id, data) {
  return sendRequest(`${BASE_URL}/stamps/${id}`, "PUT", data);
}

export async function incrementLike(stampId) {
  return sendRequest(`${BASE_URL}/stamps/${stampId}/like`, "POST");
}

export async function getS3Url(contentType) {
  const query = contentType
    ? `?contentType=${encodeURIComponent(contentType)}`
    : "";
  return sendRequest(`${BASE_URL}/s3urls${query}`, "GET");
}

// export async function sendS3Url(url, file) {
//   return sendMultipartRequest(url, "PUT", file)
// }

export async function reorderBatch(updates) {
  return sendRequest(`${BASE_URL}/stamps/reorder/batch`, "PUT", { updates });
}

export async function sendS3Url(url, file) {
  try {
    const contentType = file.type || "image/png";
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": contentType,
      },
      body: file,
    });
    return url.split("?")[0];
  } catch (err) {
    console.log(err);
    return err;
  }
}
